import { Component, computed, inject, input, signal } from '@angular/core';
import { LocalStorageService } from '@eforall/common';
@Component({
	selector: 'mobile-card',
	imports: [],
	templateUrl: './card.widget.html',
	styleUrl: './card.widget.scss'
})


export class MobileCardWidget {

	private localStorage = inject(LocalStorageService);

	public readonly header = input.required<string | undefined>();
	public readonly closeable = input<boolean>(false);

	public localStorageKey = input<string>();

	private closed = signal(false);


	public readonly hideCard = computed<boolean>(() => {
		if (this.closed()) return true;

		if (this.localStorageKey()) {
			const val = this.localStorage.allData()[this.localStorageKey()!];
			return (val ? JSON.parse(val) : false);
		}
		return false;
	});


	close() {
		this.closed.set(true);
		if (this.localStorageKey()) this.localStorage.updateData(this.localStorageKey()!, "true");
	}

}
